import { Input, Row } from '@iqueue/ui-kit'
import PickNode from '../../components/picker/PickNode'
import PickSensor from '../../components/picker/PickSensor'
import PickProfile from '../../components/picker/PickProfile'
import { useState, useCallback, useEffect } from 'react'
import { t } from '../../hooks/useTranslate'
import { v4 as uuid } from 'uuid'

export default function ResponsibilitiesUpsertForm({ model }) {

  const [selectedSensor, setSelectedSensor] = useState(undefined)
  const [selectedNode, setSelectedNode] = useState(undefined)

  const handleNodeChange = useCallback((id) => {
    setSelectedNode(id)
    setSelectedSensor(undefined)
  }, [])

  const handleSensorChange = useCallback((id) => {
    setSelectedSensor(id)
    setSelectedNode(undefined)
  }, [])

  useEffect(() => {
    setSelectedNode(!model?.nodeId && undefined)
    setSelectedSensor(!model?.sensorId && undefined)
  }, [model])

  return <div>
    <Input
      name={ 'id' }
      hidden
      value={ model.id || uuid() }
    />
    <Row>
      <PickNode
        size={ 12 }
        name={ 'nodeId' }
        current={ model }
        placeholder={ t('responsibilitiesPage.form.selectNode') }
        value={ model?.nodeId }
        onChange={ handleNodeChange }
        disabled={ selectedSensor !== undefined }
      />
    </Row>
    <Row>
      <PickProfile
        size={ 12 }
        name="profileId"
        current={ model }
        placeholder={ t('responsibilitiesPage.form.selectProfile') }
        value={ model?.profileId }
      />
    </Row>
    <Row>
      <PickSensor
        size={ 12 }
        name="sensorId"
        current={ model }
        placeholder={ t('responsibilitiesPage.form.selectSensor') }
        value={ model?.sensorId }
        onChange={ handleSensorChange }
        disabled={ selectedNode !== undefined }
      />
    </Row>
  </div>
}
